import { describeError } from '../lib/errors';
import { useT } from '../i18n';
import { Alert } from './Alert';

export function ErrorBlock({ error, onRetry }: { error: unknown; onRetry?: () => void }) {
  const t = useT();
  return (
    <div className="py-6">
      <Alert
        kind="error"
        action={
          onRetry ? (
            <button type="button" className="btn-quiet" onClick={onRetry}>
              {t('common.retry')}
            </button>
          ) : null
        }
      >
        {t(describeError(error))}
      </Alert>
    </div>
  );
}
